// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  padding: 20px 25px;
}
ion-header .logo {
  height: 100%;
}
ion-header .close {
  height: 22px;
}

.container {
  overflow-y: scroll;
}

.main_col {
  padding: 10px 25px;
}

.month_name {
  margin: 30px 0px 10px;
  font-family: Slat;
  font-size: 32px;
  line-height: 40px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: #f4ece1;
}
.month_name:first-child {
  margin-top: 0px;
}
.month .order_item {
  background: #241f21;
  margin-bottom: 10px;
  padding: 5px;
}
.month .order_item .img-block {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.month .order_item .img-block .coin_img {
  height: 20px;
}
.month .order_item .top_row,
.month .order_item .bottom_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.month .order_item .points {
  font-family: Slat;
  font-size: 17px;
  line-height: 20px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #f4ece1;
}
.month .order_item .date {
  font-family: AppFont;
  font-size: 13px;
  line-height: 121.12%;
  letter-spacing: 0.02em;
  color: rgba(244, 236, 225, 0.5);
}

.spinner-block {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.all_points {
  font-size: 10px;
  color: #f4ece1;
}

.data-block {
  text-align: end;
}

.container_message {
  height: calc(100vh - 100px);
}

.info_message_text {
  font-size: 20px;
  color: #f4ece1;
  padding: 15px 20px;
  font-family: Slat, sans-serif;
  text-transform: capitalize;
}

.load-more-text {
  background: var(--ion-color-primary);
  color: white;
  font-family: Slat, sans-serif;
  font-size: 16px;
  text-align: center;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/show-history-points/show-history-points.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AACF;AAAE;EACE,YAAA;AAEJ;AACE;EACE,YAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAIE;EACE,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,yBAAA;EAEA,cAAA;AAHJ;AAKI;EACE,eAAA;AAHN;AAOE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AALJ;AAMI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAJN;AAKM;EACE,YAAA;AAHR;AAQI;;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;AANN;AASI;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,cAAA;AARN;AAWI;EACE,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EAEA,+BAAA;AAVN;;AAcA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAXF;;AAaA;EACE,eAAA;EACA,cAAA;AAVF;;AAYA;EACE,eAAA;AATF;;AAWA;EACE,2BAAA;AARF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,0BAAA;AAPF;;AASA;EACE,oCAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;AANF","sourcesContent":["ion-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 70px;\n  padding: 20px 25px;\n  .logo {\n    height: 100%;\n  }\n\n  .close {\n    height: 22px;\n  }\n}\n\n.container {\n  overflow-y: scroll;\n}\n\n.main_col {\n  padding: 10px 25px;\n}\n\n.month {\n  &_name {\n    margin: 30px 0px 10px;\n    font-family: Slat;\n    font-size: 32px;\n    line-height: 40px;\n\n    display: flex;\n    align-items: center;\n    text-transform: uppercase;\n\n    color: #f4ece1;\n\n    &:first-child {\n      margin-top: 0px;\n    }\n  }\n\n  .order_item {\n    background: #241f21;\n    margin-bottom: 10px;\n    padding: 5px;\n    .img-block {\n      display: flex;\n      align-items: center;\n      margin-right: 10px;\n      .coin_img {\n        height: 20px;\n        // margin: 5px 10px 5px 0px;\n      }\n    }\n\n    .top_row,\n    .bottom_row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n\n    .points {\n      font-family: Slat;\n      font-size: 17px;\n      line-height: 20px;\n      letter-spacing: 0.06em;\n      text-transform: uppercase;\n\n      color: #f4ece1;\n    }\n\n    .date {\n      font-family: AppFont;\n      font-size: 13px;\n      line-height: 121.12%;\n      letter-spacing: 0.02em;\n\n      color: rgba(244, 236, 225, 0.5);\n    }\n  }\n}\n.spinner-block {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.all_points {\n  font-size: 10px;\n  color: #f4ece1;\n}\n.data-block {\n  text-align: end;\n}\n.container_message {\n  height: calc(100vh - 100px);\n}\n.info_message_text {\n  font-size: 20px;\n  color: #f4ece1;\n  padding: 15px 20px;\n  font-family: Slat, sans-serif;\n  text-transform: capitalize;\n}\n.load-more-text {\n  background: var(--ion-color-primary);\n  color: white;\n  font-family: Slat, sans-serif;\n  font-size: 16px;\n  text-align: center;\n  padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
